module.exports = {"previous":"&laquo; Anterior","next":"Próxima &raquo;"};